export default __webpack_public_path__ + "static/media/credit_card.b0e8c71c.webp";